import React from 'react'
import {
  NavItem,
  INavItemListProps,
} from '../../../interfaces/Navigation.Interface'
import Icon from '../../svg/Icon'

const SocialNavItemsList = ({ navItems, id }: INavItemListProps) => (
  <ul className="social-media">
    {navItems.map((item: NavItem, index) => {
      return (
        <React.Fragment key={`${id}-${index}`}>
          <li>
            <a href={item.absolute} target="_blank" rel="noopener noreferrer">
              <Icon name={item.icon} />
              <span className="sr-only">{item.title}</span>
            </a>
          </li>
        </React.Fragment>
      )
    })}
  </ul>
)

export default SocialNavItemsList
